import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../../hooks/useTranslation'

export const WithShortsTooltip = (props: any) => {
  const { setWithShortsStatus } = props
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white   h-auto absolute border-[3px] border-main  rounded-[20px] ',
        {
          'w-[330px] bottom-5 left-0': !isMobile,
          'w-[280px] bottom-5 -right-10': isMobile,
        }
      )}
      onMouseLeave={() => {
        setWithShortsStatus(false)
      }}
    >
      <p className=" md:text-base  text-[10px]">
        <span className="font-bold text-[20px]">{t('productVideoEditor.withShortsTooltip.title')}</span>
      </p>
      <p>
        {t('productVideoEditor.withShortsTooltip.description')}
      </p>
      <p className="text-error text-[14px]">{t('productVideoEditor.withShortsTooltip.discountEvent')}</p>
      <p className="flex gap-2  text-[14px] items-center">
        <img
          src="assets/img/cash.png"
          alt="coupang"
          className="w-[11px] h-[13px]"
        />
        <span className="font-bold">{t('productVideoEditor.withShortsTooltip.oneShortForm')}</span>{' '}
        <s className="text-[#5E6068]">{t('productVideoEditor.withShortsTooltip.originalPrice')}</s>{' '}
        <span className="font-bold text-main">{t('productVideoEditor.withShortsTooltip.discountPrice')}</span>
      </p>
    </div>
  )
}
